module.exports = __webpack_public_path__ + "img/icon_go_out.svg";